<template>
  <div :style="{backgroundColor: projectUIDesignWideData.backgroundColor}" class="customer-uidesignwide-div">
    <div class="customer-uidesignwide-imagediv">
      <img :src="images[imageIndex]">
    </div>
    <div class="customer-uidesignwide-buttondiv">
      <div  v-if="images.length > 1" class="customer-uidesignwide-button" @click="changeImage(index)" v-for="(image, index) in images" :id="index"
           :style="{color: index === imageIndex ? projectUIDesignWideData.colorNew : 'white'}">
        <img :src="projectUIDesignWideData.image" v-if="index === imageIndex">
        {{index + 1}}
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'CustomerUIDesignWideData',
    props: {
      projectUIDesignWideData: {
        backgroundColor: String,
        images: Array,
        imagesMobile: Array,
        colorNew: String,
        image: String
      }
    },
    data() {
      return {
        images: this.projectUIDesignWideData.images,
        chosenimage: "",
        imageIndex: 0,
      }
    },
    methods:
      {
        changeImage: function (index) {
          console.log(this);
          this.imageIndex = index;
        }
      },
    created() {
      this.images = window.innerWidth > 600 ? this.projectUIDesignWideData.images : this.projectUIDesignWideData.imagesMobile
    }
  }
</script>
<style lang="scss" scoped>
  @import "../../assets/scss/customerUIDesignWide.scss";
</style>



// WEBPACK FOOTER //
// src/pages/CustomersComponents/CustomerUIDesignWide.vue